import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import ExtraDescription from "src/Component/ExtraDescription";
import { useEffect, useState } from "react";
import store from "src/Reducers/store";
import { useSelector } from "react-redux";

const PageId = 5;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const [step, setStep] = useState(0);

  const baseImageUrl = `${Config.BASE_URL}/images/screen_${PageId}/`;
  const rightSideImage_0 = `${baseImageUrl}right_0.png`;
  const rightSideImage_1 = `${baseImageUrl}right_1.png`;
  const rightSideImage_2 = `${baseImageUrl}right_2.png`;
  const rightSideImage_3 = `${baseImageUrl}right_3.png`;
  const rightSideImage_4 = `${baseImageUrl}right_4.png`;
  const rightSideImage_5 = `${baseImageUrl}right_5.png`;
  const rightSideImage_6 = `${baseImageUrl}right_6.png`;

  const rightSideComponentBaseStyle: React.CSSProperties = {
    position: "absolute",
    right: 0,
    bottom: 0,
    transition: "all 1.6s ease-in-out",
    height: "100%",
  };

  const backButtonConfig = {
    label: "Back",
    type: "back",
    startIcon: { icon: "arrow-right", color: "#fff" },
    onClick: () => setCurrentPage(BackPageId),
    style: { gap: "var(--width-16)" },
  };

  const nextButtonConfig = {
    label: "Next",
    type: "next",
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NextPageId),
    style: { gap: "var(--width-16)" },
  };

  useEffect(() => {
    let timeoutId: any;
    if (currentPage === PageId) {
      if (step === 0) timeoutId = setTimeout(() => setStep(step + 1), 200);
    } else setStep(0);

    return () => {
      setStep(0);
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const stepsTime = [3000, 1000, 1000, 1000, 1000, 1000, 1000];

  useEffect(() => {
    let timeoutId: any;
    if (step > 0 && step <= stepsTime.length) timeoutId = setTimeout(() => setStep(step + 1), stepsTime[step - 1]);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  return {
    // bgImage: `${Config.BASE_URL}/images/BG/bg_${PageId}.jpg`,
    title: "A network that adapts\nto your needs.",
    description: `Your home is getting smarter, and your network\nshould keep up. Infosys Connectivity Platform\nensures seamless integration of all your devices,\ncreating a unified, hassle-free experience.`,
    leftAfterDescription: (
      <ExtraDescription
        text={`<ul><li>Plug & Play Compatibility – Automatically\nrecognizes and optimizes smart devices upon\nconnection.</li>\n<li>Intelligent Bandwidth Allocation – Ensures\nuninterrupted performance for security cameras,\nsmart speakers, and home automation.</li>\n<li>Customer-Centric Approach: Improve\nreliability and reduce downtime, enhancing\noverall satisfaction.</li></ul>`}
      />
    ),
    rightSideComponent: (
      <>
        <img
          src={`${Config.BASE_URL}/images/BG/bg_${PageId}.jpg`}
          alt=""
          style={{
            ...rightSideComponentBaseStyle,
            transition: "all 3s ease-in-out",
            opacity: step >= 1 ? 1 : 0,
            transform: `scale(${step >= 1 ? "1" : "0.3"})`,
          }}
        />
        <img
          src={rightSideImage_0}
          alt=""
          style={{ ...rightSideComponentBaseStyle, opacity: step >= 2 ? 1 : 0, transform: `scale(${step >= 2 ? "1" : "0.4"})` }}
        />
        <img
          src={rightSideImage_1}
          alt=""
          style={{ ...rightSideComponentBaseStyle, opacity: step >= 3 ? 1 : 0, transform: `scale(${step >= 3 ? "1" : "0.4"})` }}
        />
        <img
          src={rightSideImage_2}
          alt=""
          style={{ ...rightSideComponentBaseStyle, opacity: step >= 4 ? 1 : 0, transform: `scale(${step >= 4 ? "1" : "0.4"})` }}
        />
        <img
          src={rightSideImage_3}
          alt=""
          style={{ ...rightSideComponentBaseStyle, opacity: step >= 5 ? 1 : 0, transform: `scale(${step >= 5 ? "1" : "0.4"})` }}
        />
        <img
          src={rightSideImage_4}
          alt=""
          style={{ ...rightSideComponentBaseStyle, opacity: step >= 6 ? 1 : 0, transform: `scale(${step >= 6 ? "1" : "0.4"})` }}
        />
        <img
          src={rightSideImage_5}
          alt=""
          style={{ ...rightSideComponentBaseStyle, opacity: step >= 7 ? 1 : 0, transform: `scale(${step >= 7 ? "1" : "0.4"})` }}
        />
        <img
          src={rightSideImage_6}
          alt=""
          style={{ ...rightSideComponentBaseStyle, opacity: step >= 8 ? 1 : 0, transform: `scale(${step >= 8 ? "1" : "0.4"})` }}
        />
      </>
    ),
    back: backButtonConfig,
    next: nextButtonConfig,
  };
};

export default DATA;
